@if(patientLastFirstName() && patientDateOfBirth()) {
  <div class="flex flex-row justify-between px-5 py-2 mb-6 bg-gray-600 text-white font-semibold tracking-widest w-full">
    <div>{{ patientLastFirstName() | uppercase }}</div>
    <div>DOB {{ patientDateOfBirth() | date: 'M/d/yyyy'}}</div>
    <div>AGE {{ patientDateOfBirth()! | age }}</div>
  </div>
} @else {
  <div class="p-3 mb-6 border border-red-600 text-red-600">ERROR: Selected Patient is NULL: Unable to render banner.</div>
}



